import styled from "@emotion/styled"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "../skeleton"

export const FinancingFormProductDetailsSkeleton = () => (
	<Layout>
		<Skeleton.Heading size="lg" $width="25%" />
		<Skeleton.Text $width="75%" />
		<Skeleton.List entries={10} />
	</Layout>
)

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
`
